export const UPDATE_REGISTERED_SKETCHES = 'UPDATE_REGISTERED_SKETCHES';
export const UPDATE_SKETCH_INDEX_SELECTED = 'UPDATE_SKETCH_INDEX_SELECTED';

export const UPDATE_LAYER_MENU_OPEN = 'UPDATE_LAYER_MENU_OPEN';
export const UPDATE_MASTER_MENU_OPEN = 'UPDATE_MASTER_MENU_OPEN';
export const UPDATE_CATALOGUE_OPEN = 'UPDATE_CATALOGUE_OPEN';
export const UPDATE_AUX_INPUT_VISIBLE = 'UPDATE_AUX_INPUT_VISIBLE';

export const UPDATE_USER_LOGGED_IN = 'UPDATE_USER_LOGGED_IN ';
export const UPDATE_USER = 'UPDATE_USER';

export const UPDATE_AUDIO_PLAYER_OPEN = 'UPDATE_AUDIO_PLAYER_OPEN';
export const UPDATE_IS_PLAYING = 'UPDATE_IS_PLAYING';
export const UPDATE_CURRENT_SOUND = 'UPDATE_CURRENT_SOUND';
export const UPDATE_AUDIO_IS_LOADING = 'UPDATE_AUDIO_IS_LOADING';
export const UPDATE_TRACKS = 'UPDATE_TRACKS';
export const UPDATE_SOUND_DURATION = 'UPDATE_SOUND_DURATION';
export const UPDATE_CURRENT_TRACK_INDEX = 'UPDATE_CURRENT_TRACK_INDEX';
export const UPDATE_CURRENT_TRACK_TIME = 'UPDATE_CURRENT_TRACK_TIME';
export const UPDATE_SONG_PROGRESS = 'UPDATE_SONG_PROGRESS';
